{
  "button": {
    "hyperlink": {
      "ariaLabel": "add hyperlink"
    },
    "image": {
      "ariaLabel": "add photo"
    },
    "video": {
      "ariaLabel": "add video"
    }
  }
}
